import {
    slideDown,
    slideUp,
} from '@js/common/all-function.js';

const DeviceMenu = () => {
    const header = document.querySelector('header.main-header');
    const hamBurger = document.querySelector('.hamburger');
    const overlay = document.querySelectorAll('.mbnav__backdrop, .mbnav__close');
    const body = document.body;
    const mbnav = document.querySelector('.mbnav');

    function menuClose() {
        hamBurger.classList.remove('is-clicked');
        body.classList.remove('scroll-fixed');
        mbnav.classList.remove('is-open');
        mbnav.querySelectorAll('.menu-wrap li').forEach(li => li.classList.remove('is-open'));
        document.querySelector('.mbnav__inner > .menu-wrap').style.setProperty('--leftSlide', '0');
        document.querySelectorAll('.mbnav__inner .mbnav__caret').forEach(caret => {
            // Find the parent element and locate the .sub-menu (ul)
            const subMenu = this.parentNode.querySelector('ul.sub-menu');
            slideUp(subMenu); // Assuming slideUp is a function that slides the element up
        });
    }

    // Overlay click
    overlay.forEach(el => {
        el.addEventListener('click', menuClose);
    });

    // Hamburger click
    window.resetHamburger = function () {
        hamBurger.classList.remove('is-clicked');
        mbnav.classList.remove('is-open');
        body.classList.remove('scroll-fixed');
    };

    hamBurger.addEventListener('click', () => {
        if (typeof window.resetSearch === "function") {
            window.resetSearch();
        }

        if (hamBurger.classList.contains('is-clicked')) {
            menuClose();
        } else {
            hamBurger.classList.add('is-clicked');
            mbnav.classList.add('is-open');
            body.classList.add('scroll-fixed');
        }
    });

    // Mark has-sub
    const mbnavState = document.querySelector('.mbnav__state');
    const clickable = mbnavState ? mbnavState.getAttribute('data-clickable') === 'true' : false;
    const menuItems = document.querySelectorAll('.mbnav ul.menu > li');

    menuItems.forEach(li => {
        if (li.querySelector('ul')) {
            li.classList.add('has-sub');
            const ul = li.querySelector('ul');
            ul.classList.add('sub-menu');
            const link = li.querySelector('a');
            if (link) {
                const caret = document.createElement('em');
                caret.className = 'mbnav__caret';
                link.insertAdjacentElement('afterend', caret);
            }
        }
    });

    // Handle caret triggers
    const carets = document.querySelectorAll('.mbnav .has-sub>.mbnav__caret');
    carets.forEach(caret => {
        if (clickable) {
            caret.classList.add('trigger-caret');
        } else {
            const link = caret.previousElementSibling;
            if (link && link.tagName === 'A') {
                link.classList.add('trigger-caret');
                link.setAttribute('href', 'javascript:;');
            }
        }
    });

    // Wrap elements
    const inner = document.querySelector('.mbnav__inner');
    if (inner) {
        const wrapper = document.createElement('div');
        wrapper.className = 'menu-wrap';
        const innerWrap = document.createElement('div');
        innerWrap.className = 'menu-inner';

        while (inner.firstChild) {
            innerWrap.appendChild(inner.firstChild);
        }

        wrapper.appendChild(innerWrap);
        inner.appendChild(wrapper);
    }

    // Open sub-menu
    document.querySelectorAll('.mbnav .has-sub>.trigger-caret').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const li = trigger.closest('li');
            const siblings = li.parentElement.children;
            Array.from(siblings).forEach(sib => {
                if (sib !== li) {
                    sib.classList.remove('is-open');
                }
            });
            if (!li.classList.contains('is-open')) {
                li.classList.add('is-open');
            } else {
                li.classList.remove('is-open');
            }
            body.classList.add('scroll-fixed');
        });
    });

    // Forward slide
    document.querySelectorAll('.mbnav__inner .mbnav__caret').forEach(caret => {
        caret.addEventListener('click', function() {
            // Find the parent element and locate the .sub-menu (ul)
            const subMenu = this.parentNode.querySelector('ul.sub-menu');

            // Slide toggle the sub-menu
            if (subMenu.style.display === 'none' || !subMenu.style.display) {
                slideDown(subMenu); // Assuming slideDown is a function that slides the element down
            } else {
                slideUp(subMenu); // Assuming slideUp is a function that slides the element up
            }

            // Slide up all other sibling sub-menus
            Array.from(this.parentNode.parentNode.children).forEach(sibling => {
                const siblingSubMenu = sibling.querySelector('ul.sub-menu');
                if (sibling !== this.parentNode && siblingSubMenu) {
                    slideUp(siblingSubMenu); // Close other sub-menus
                }
            });
        });
    });

    // Padding adjustment
    const headerHeight = header.offsetHeight;
    const menuInners = document.querySelectorAll('.mbnav .menu-wrap .menu-inner');

    menuInners.forEach(inner => {
        inner.style.paddingTop = `${headerHeight}px`;
    });

    window.addEventListener('resize', () => {
        menuInners.forEach(inner => {
            inner.style.paddingTop = `${headerHeight}px`;
        });
    });
};

export default DeviceMenu;
